import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import ThumbUpicon from '@material-ui/icons/ThumbUp';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';

import LineChart from './charts/LineChart';
//import PieChart from './charts/PieChart';
import AuditCard from './utils/AuditCard';
import Calendar from '../component/utils/Calendar';
import AuditsGridList from '../component/utils/AuditsGridList';
import moment from "moment";

const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    display: 'block', // Fix IE11 issue.
  },
  card: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 275,
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE11 issue.
    marginTop: theme.spacing.unit,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },
  button: {
    marginTop: theme.spacing.unit * 3,
  },
  input: {
    display: 'none',
  },
  chartContainer: {
    marginLeft: -40,
  },
  title: {
    marginBottom: 16
  },
  media: {
    marginTop: theme.spacing.unit * 2,
    // ⚠️ object-fit is not supported by IE11.
    objectFit: 'cover',
  },
  marginDivier: {
    marginTop: theme.spacing.unit * 5,
  },
  iconThumbUp: {
    fontSize: 60,
    display: 'block',
    margin: '30px auto',
    color: '#ccc',
  },
  legendList:{
    display: "flex",
  },
  legendItem:{
  }
});

class Dashboard extends React.Component {

  render() {
    return (
      <React.Fragment>
        <CssBaseline />
        <Typography variant="display1" gutterBottom>
          Les 6 prochains audits {this.props.invoiceTotal}
        </Typography>
        <Grid container spacing={24} >
          {this.props.audits.filter(a => (a.status === "appointment" && moment(a.date).isSameOrAfter(moment()) ) ).sort(function(a,b){
              return moment(a.date) - moment(b.date);
          }).slice(0, 6).map(audit => (
            <Grid item key={audit.id} xs={12} sm={12} md={4} lg={2} >
              <AuditCard audit={audit} displaySnackbar={this.props.displaySnackbar} closeSnackbar={this.props.closeSnackbar} />
            </Grid>
          ))}
        </Grid>
        <Grid container spacing={24}>
          {/*<Grid item xs={12} sm={12} md={6} lg={4}>
            <Card className={this.props.classes.card}>
              <CardContent>
                <Typography variant="display1" className={this.props.classes.title} color="textSecondary">
                  Status des audits
                </Typography>
                <Typography component="div" style={{width: "100%"}}>
                  <PieChart data={this.props.pieChartData} />
                </Typography>
              </CardContent>
            </Card>
          </Grid>*/}

          <Grid item xs={12} >
            <Grid container spacing={24}>

            <Grid item xs={12} sm={6} md={3}>
              <Card className={this.props.classes.card}>
                <CardContent>
                  <Typography variant="display1" className={this.props.classes.title} color="textSecondary">
                    Total facturé
                  </Typography>
                  <Typography variant="caption" >
                    (TTC) ce mois-ci
                  </Typography>
                  <Typography variant="body1">
                    {this.props.invoicesTotal} €
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            </Grid>
          </Grid>

          <Grid item xs={12} >
            <Card className={this.props.classes.card}>
              <CardContent>
                <Calendar history={this.props.history} events={this.props.events}/>
              </CardContent>
              <CardActions>
                  <List dense={false} className={this.props.classes.legendList}>
                      <ListItem className={this.props.classes.legendItem}>
                          <ListItemAvatar>
                              <Avatar style={{backgroundColor: "#4ca5c3", height: 10, width: 10}}/>
                          </ListItemAvatar>
                          <ListItemText primary="En attente" style={{padding: 5}}/>
                      </ListItem>
                      <ListItem className={this.props.classes.legendItem}>
                          <ListItemAvatar>
                              <Avatar style={{backgroundColor: "#ffc500", height: 10, width: 10}}/>
                          </ListItemAvatar>
                          <ListItemText primary="Rendez-vous non validé" style={{padding: 5}}/>
                      </ListItem>
                      <ListItem className={this.props.classes.legendItem}>
                          <ListItemAvatar>
                              <Avatar style={{backgroundColor: "#ac95dc", height: 10, width: 10}}/>
                          </ListItemAvatar>
                          <ListItemText primary="Rendez-vous validé" style={{padding: 5}}/>
                      </ListItem>
                      <ListItem className={this.props.classes.legendItem}>
                          <ListItemAvatar>
                              <Avatar style={{backgroundColor: "#c3c34c", height: 10, width: 10}}/>
                          </ListItemAvatar>
                          <ListItemText primary="Écart" style={{padding: 5}}/>
                      </ListItem>
                      <ListItem className={this.props.classes.legendItem}>
                          <ListItemAvatar>
                              <Avatar style={{backgroundColor: "#38a84c", height: 10, width: 10}}/>
                          </ListItemAvatar>
                          <ListItemText primary="Validé" style={{padding: 5}}/>
                      </ListItem>
                      <ListItem className={this.props.classes.legendItem}>
                          <ListItemAvatar>
                              <Avatar style={{backgroundColor: "#e74c3c", height: 10, width: 10}}/>
                          </ListItemAvatar>
                          <ListItemText primary="Rejeté" style={{padding: 5}}/>
                      </ListItem>
                  </List>
              </CardActions>
            </Card>
          </Grid>

            <Grid item xs={12}>
              <Grid container spacing={24}>

                <Grid item xs={12} sm={6} md={3}>
                  <Card className={this.props.classes.card}>
                    <CardContent>
                      <Typography variant="display1" className={this.props.classes.title} color="textSecondary">
                        {this.props.audits.filter(audit => audit.status === 'waiting').length + " audit(s) sans rendez-vous"}
                      </Typography>

                      {this.props.audits.filter(audit => audit.status === 'waiting').length > 0 ? (
                          <AuditsGridList audits={this.props.audits.filter(audit => audit.status === 'waiting')}/>
                      ) : (<ThumbUpicon className={this.props.classes.iconThumbUp}/>)}
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Card className={this.props.classes.card}>
                    <CardContent>
                      <Typography variant="display1" className={this.props.classes.title} color="textSecondary">
                        {this.props.audits.filter(audit => audit.status === 'appointment').length + " rapport(s) à traiter"}
                      </Typography>
                      {this.props.audits.filter(audit => audit.status === 'appointment').length > 0 ? (
                          <AuditsGridList audits={this.props.audits.filter(audit => audit.status === 'appointment')}/>
                      ) : (<ThumbUpicon className={this.props.classes.iconThumbUp}/>)}
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Card className={this.props.classes.card}>
                    <CardContent>
                      <Typography variant="display1" className={this.props.classes.title} color="textSecondary">
                        {this.props.audits.filter(audit => audit.status === 'issue').length + " audit(s) avec écart(s)"}
                      </Typography>
                      {this.props.audits.filter(audit => audit.status === 'issue').length > 0 ? (
                          <AuditsGridList audits={this.props.audits.filter(audit => audit.status === 'issue')}/>
                      ) : (<ThumbUpicon className={this.props.classes.iconThumbUp}/>)}
                    </CardContent>
                  </Card>
                </Grid>

              </Grid>
              <Grid item xs={12} sm={6} md={3}>
		<Card className={this.props.classes.card}>
    		  <CardContent>
     		   <Typography variant="display1" className={this.props.classes.title} color="textSecondary">
       		     {this.props.audits.filter(audit => audit.status === 'issue_invoiced').length + " audit(s) avec écart(s) facturés"}
      		   </Typography>
      		   {this.props.audits.filter(audit => audit.status === 'issue_invoiced').length > 0 ? (
          	      <AuditsGridList audits={this.props.audits.filter(audit => audit.status === 'issue_invoiced')}/>
		      ) : (<ThumbUpicon className={this.props.classes.iconThumbUp}/>)}
		  </CardContent>
  		</Card>
              </Grid>
            </Grid>

          <Grid item xs={12} sm={12}>
            <Card className={this.props.classes.card}>
              <CardContent>
                <Typography variant="display1" gutterBottom className={this.props.classes.title} color="textSecondary">
                  Ajout/Édition des audits
                </Typography>
                <Typography component="div" style={{width: "100%"}} className={this.props.classes.chartContainer}>
                  <LineChart data={this.props.lineChartData}/>
                </Typography>
              </CardContent>
            </Card>
          </Grid>

        </Grid>

      </React.Fragment>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Dashboard);



// WEBPACK FOOTER //
// ./src/component/dashboard.js